var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "centered d-flex neu-cards-slider mx-auto",
      class: { black: _vm.black },
      style: _vm.white
        ? ""
        : "background-image: url(/static-appopensalud/img/bgs/opt/fondogris.jpg),linear-gradient(to top, #eee, transparent)"
    },
    [
      _c(
        "b-col",
        {
          staticClass: "text-center my-auto pt-5 pb-sm-5",
          staticStyle: { "margin-top": "3rem !important" },
          attrs: { cols: "12" }
        },
        [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" " + _vm._s(_vm.iva) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.cards, function(card) {
          return _c(
            "b-col",
            {
              key: _vm.cards[card],
              staticClass: "card-ctn2",
              attrs: { md: "12" }
            },
            [
              _c(
                "div",
                [
                  _c("neu-card-pricing-prime", {
                    attrs: {
                      id: card.id,
                      black: _vm.black,
                      text: card.text,
                      priceSubtitle: card.priceSubtitle,
                      priceTitle: card.priceTitle,
                      subtitle: card.subtitle,
                      subtitle1: card.subtitle1,
                      subtitle2: card.subtitle2,
                      title: card.title,
                      titleLines: card.titleLines,
                      subtitleLines: card.subtitleLines
                    }
                  })
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.cards2, function(card) {
          return _c(
            "b-col",
            {
              key: _vm.cards[card],
              staticClass: "card-ctn2",
              attrs: { md: "12" }
            },
            [
              _c(
                "div",
                [
                  _c("neu-card-pricing-prime", {
                    attrs: {
                      id: card.id,
                      black: _vm.black,
                      text: card.text,
                      priceSubtitle: card.priceSubtitle,
                      priceTitle: card.priceTitle,
                      subtitle: card.subtitle,
                      subtitle1: card.subtitle1,
                      subtitle2: card.subtitle2,
                      title: card.title,
                      titleLines: card.titleLines,
                      subtitleLines: card.subtitleLines
                    }
                  })
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.cards3, function(card) {
          return _c(
            "b-col",
            {
              key: _vm.cards[card],
              staticClass: "card-ctn2",
              attrs: { md: "12" }
            },
            [
              _c(
                "div",
                [
                  _c("neu-card-pricing-prime", {
                    attrs: {
                      id: card.id,
                      black: _vm.black,
                      text: card.text,
                      priceSubtitle: card.priceSubtitle,
                      priceTitle: card.priceTitle,
                      subtitle: card.subtitle,
                      subtitle1: card.subtitle1,
                      subtitle2: card.subtitle2,
                      title: card.title,
                      titleLines: card.titleLines,
                      subtitleLines: card.subtitleLines
                    }
                  })
                ],
                1
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "text-center my-auto pt-lg-0 pt-5 pb-sm-5",
          staticStyle: { "margin-top": "5rem !important" },
          attrs: { cols: "12" }
        },
        [
          !_vm.$uiHelpers.isMobile
            ? _c("iframe", {
                attrs: {
                  width: "600",
                  height: "315",
                  src: "https://www.youtube.com/embed/pVWnBU3Pxe8",
                  title: "YouTube video player",
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: ""
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$uiHelpers.isMobile
            ? _c("iframe", {
                attrs: {
                  width: "300",
                  height: "315",
                  src: "https://www.youtube.com/embed/pVWnBU3Pxe8",
                  title: "YouTube video player",
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                  allowfullscreen: ""
                }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.hasConditionsSlot
        ? _c(
            "b-col",
            { staticClass: "text-center pb-5 pb-md-0", attrs: { cols: "12" } },
            [_vm._t("conditions")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-434cc0ec", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-434cc0ec","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/ui/NeuCardsSliderPricingPrime.vue
// module id = 3232
// module chunks = 36 37